export default "__VITE_ASSET__i$$DPIHK__"